<template>
  <!-- TEMPORAL -->
  <img
    :src="require('@/assets/Images/Colecciones/QUITO/QUITO&FONDO.webp')"
    style="object-fit: cover"
    alt=""
    class="canvas"
    :class="{
      open: Open,
    }"
  />
  <!-- TEMPORAL -->
</template>

<script>
export default {
  name: "Canvas",
  props: {
    Open: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.canvas {
  width: 100%;
  height: 100%;
  -webkit-transition: width 0.35s ease-in-out;
  -moz-transition: width 0.35s ease-in-out;
  -ms-transition: width 0.35s ease-in-out;
  -o-transition: width 0.35s ease-in-out;
  transition: width 0.35s ease-in-out;
  &.open {
    width: calc(100% - 350px);
    -webkit-transition: width 0.35s ease-in-out;
    -moz-transition: width 0.35s ease-in-out;
    -ms-transition: width 0.35s ease-in-out;
    -o-transition: width 0.35s ease-in-out;
    transition: width 0.35s ease-in-out;
  }
}
</style>
